import React from 'react';
import { Section } from './ui/Section';
import { Play } from 'lucide-react';
export function Videos() {
  const videos = [{
    id: 1,
    title: 'Live at La Vaquera — March 2025',
    image: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    id: 2,
    title: 'Acoustic Set — Backyard Sessions',
    image: 'https://images.unsplash.com/photo-1511192336575-5a79af67a629?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    id: 3,
    title: 'Full Band Rehearsal',
    image: 'https://images.unsplash.com/photo-1598387181032-a3103a2db5b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }];
  return <Section id="videos" className="bg-tx-primary" data-id="element-184">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-185">
        <div data-id="element-186">
          <h2 className="text-5xl md:text-7xl text-tx-cream" data-id="element-187">
            Live <span className="text-tx-red" data-id="element-188">Performances</span>
          </h2>
          <p className="text-tx-cream/60 font-body text-lg mt-4 max-w-2xl" data-id="element-189">
            Experience the energy of a Texarkana show. From intimate acoustic
            sets to full-blown honky-tonk throwdowns.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-190">
        {videos.map(video => <div key={video.id} className="group cursor-pointer" data-id="element-191">
            <div className="relative aspect-video bg-tx-secondary border border-tx-border overflow-hidden mb-4" data-id="element-192">
              <img src={video.image} alt={video.title} className="w-full h-full object-cover opacity-60 grayscale group-hover:scale-105 group-hover:opacity-80 transition-all duration-700" data-id="element-193" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-194">
                <div className="w-16 h-16 rounded-full bg-tx-primary/80 border border-tx-cream/20 flex items-center justify-center backdrop-blur-sm group-hover:bg-tx-red group-hover:border-tx-red transition-all duration-300 group-hover:scale-110" data-id="element-195">
                  <Play className="w-6 h-6 text-tx-cream ml-1 fill-current" data-id="element-196" />
                </div>
              </div>
            </div>
            <h3 className="font-heading text-2xl text-tx-cream group-hover:text-tx-red transition-colors tracking-wider" data-id="element-197">
              {video.title}
            </h3>
          </div>)}
      </div>
    </Section>;
}